export enum MathVaultEvents {
  CLICK_ON_CHECK_ANSWER_BTN = 'check_answer',
  OPENED_HELP_MODAL = 'open_help_modal',
  CLOSED_HELP_MODAL = 'close_help_modal',
  CLICK_ON_QUESTION_IMAGE = 'preview_question_image',
  CLICK_ON_PREVIOUS_BTN = 'click_previous_button',
  CLICK_ON_SKIP_BTN = 'click_skip_button',
  OPENED_AUTHENTICATION_PROMPT = 'open_auth_prompt',
  CLOSE_LOGIN_PROMPT = 'close_login_prompt',
  CORRECT_ANSWER_STREAK = 'correct_answer_streak',
}

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type MathVaultPathObject = {
  elevator: string
  chest: string
  level: string
  activity: string
  room: string
}
